module.exports = __webpack_public_path__ + "static/1-3a90b67da4e971c527e6f4d16679ba7c.png";